import { useMutation, useQuery } from '@tanstack/react-query';
import { addCollectionNote, getCollectionNotes } from '../collectionNoteService';
import type { GetCollectionNotesParams } from '../schemas/loanServiceSchemas/getCollectionNotesParams';

/**
 * Hook for adding notes to ledger accounts (collection notes)
 */
export const useAddCollectionNote = <TError = Error, TContext = unknown>(
  options?: any
) => {
  return useMutation<
    Awaited<ReturnType<typeof addCollectionNote>>,
    TError,
    { accountId: string; note: string; context?: string; createdBy?: string },
    TContext
  >({
    mutationFn: ({ accountId, note, context, createdBy }) => addCollectionNote(accountId, note, context, createdBy),
    ...options,
  });
};

/**
 * Hook for retrieving notes for a ledger account
 */
export const useGetCollectionNotes = <TError = Error>(
  accountId: string,
  params?: GetCollectionNotesParams,
  options?: any
) => {
  return useQuery<Awaited<ReturnType<typeof getCollectionNotes>>, TError>({
    queryKey: ['collection-notes', accountId, params],
    queryFn: () => getCollectionNotes(accountId, params),
    ...options,
  });
};
